import React from "react";
import { Route, Routes } from "react-router-dom";
import GeneralView from "./general-view";
import Comissions from "./comissions";
import ComissionDetail from "./comissions/detail";

export default function Investigaciones() {
  return (
    <div>
      <div className="border-b border-zinc-300 pb-3 ">
        <div className="ml-12 border-l border-zinc-300 pl-4">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-zinc-800">
            Investigaciones
          </h1>
        </div>
      </div>

      <Routes>
        <Route path="/" element={<GeneralView />} />
        <Route path="comisiones/" element={<Comissions />} />
        <Route path="comisiones/:id" element={<ComissionDetail />} />
      </Routes>
    </div>
  );
}
